import { render } from "./PexCollectionAssetActionNext.vue?vue&type=template&id=6b09a573&scoped=true"
import script from "./PexCollectionAssetActionNext.vue?vue&type=script&lang=js"
export * from "./PexCollectionAssetActionNext.vue?vue&type=script&lang=js"

import "./PexCollectionAssetActionNext.vue?vue&type=style&index=0&id=6b09a573&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b09a573"]])

export default __exports__